import React from 'react'

function Statistics() {
  return (
    <div>
      
    </div>
  )
}

export default Statistics
